<template>
	<div id="pageInfo">
		<div class="text-h4 text-weight-bold" id="pageTitle">{{ $t(title) }}</div>
		<div class="q-py-xs" id="pageDescription" v-if="description">{{ $t(description) }}</div>
	</div>
	<div v-if="visitCodeQr?.enabled && visitDetails?.visitCode" class="visit-code-container">
		<b>{{ visitDetails.visitCode }}</b>
		<img v-if="visitCodeQr.generatorUrl" :src="`${visitCodeQr.generatorUrl}?code=${visitDetails.visitCode}&width=${visitCodeQr.width}`" />
	</div>
</template>

<style lang="less" scoped src="./complete-page.less"></style>
<script lang="ts" src="./complete-page.ts"></script>